/* tslint:disable */
/* eslint-disable */
//----------------------
// <auto-generated>
//     Generated using the NSwag toolchain v13.14.7.0 (NJsonSchema v10.5.2.0 (Newtonsoft.Json v12.0.0.0)) (http://NSwag.org)
// </auto-generated>
//----------------------
// ReSharper disable InconsistentNaming

import { getAuth0Token, getVectorBaseUrl, transformApiResult, transformRequestOptions } from './VectorClientHelpers';
export class VectorClientBase { 

    protected transformOptions(options: any) {
        return this.getToken().then(newToken => transformRequestOptions(newToken, options));
      }
  
  protected transformResult(url: string, response: Response, processor: (response: Response) => any) {
    return transformApiResult(url, response, processor);
  }

  protected getBaseUrl(urlTemplate: string, defaultUrl: string | undefined): string {
    return getVectorBaseUrl(urlTemplate, defaultUrl);
  }

  private async getToken() {
    return getAuth0Token();
  }
}

export interface IVaultsClient {
    /**
     * @return Success
     */
    vaultsAll(): Promise<VaultApiModel[]>;
    /**
     * @param body (optional) 
     * @return Success
     */
    vaultsPOST(body?: VaultCreationRequest | undefined): Promise<VaultApiModel>;
    /**
     * @return Success
     */
    vaultsGET(id: number): Promise<VaultApiModel>;
    /**
     * @param body (optional) 
     * @return Success
     */
    vaultsPUT(id: number, body?: VaultUpdateRequest | undefined): Promise<VaultApiModel>;
    /**
     * @return Success
     */
    vaultsDELETE(id: number): Promise<VaultApiModel>;
    /**
     * @return Success
     */
    archive(id: number): Promise<VaultApiModel>;
}

export class VaultsClient extends VectorClientBase implements IVaultsClient {
    private http: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> };
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(baseUrl?: string, http?: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> }) {
        super();
        this.http = http ? http : <any>window;
        this.baseUrl = this.getBaseUrl("", baseUrl);
    }

    /**
     * @return Success
     */
    vaultsAll(): Promise<VaultApiModel[]> {
        let url_ = this.baseUrl + "/api/apps/primus/Vaults";
        url_ = url_.replace(/[?&]$/, "");

        let options_ = <RequestInit>{
            method: "GET",
            headers: {
                "Accept": "text/plain"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.transformResult(url_, _response, (_response: Response) => this.processVaultsAll(_response));
        });
    }

    protected processVaultsAll(response: Response): Promise<VaultApiModel[]> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(VaultApiModel.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<VaultApiModel[]>(<any>null);
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    vaultsPOST(body?: VaultCreationRequest | undefined): Promise<VaultApiModel> {
        let url_ = this.baseUrl + "/api/apps/primus/Vaults";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ = <RequestInit>{
            body: content_,
            method: "POST",
            headers: {
                "Content-Type": "application/json",
                "Accept": "text/plain"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.transformResult(url_, _response, (_response: Response) => this.processVaultsPOST(_response));
        });
    }

    protected processVaultsPOST(response: Response): Promise<VaultApiModel> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = VaultApiModel.fromJS(resultData200);
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<VaultApiModel>(<any>null);
    }

    /**
     * @return Success
     */
    vaultsGET(id: number): Promise<VaultApiModel> {
        let url_ = this.baseUrl + "/api/apps/primus/Vaults/{id}";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        let options_ = <RequestInit>{
            method: "GET",
            headers: {
                "Accept": "text/plain"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.transformResult(url_, _response, (_response: Response) => this.processVaultsGET(_response));
        });
    }

    protected processVaultsGET(response: Response): Promise<VaultApiModel> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = VaultApiModel.fromJS(resultData200);
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<VaultApiModel>(<any>null);
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    vaultsPUT(id: number, body?: VaultUpdateRequest | undefined): Promise<VaultApiModel> {
        let url_ = this.baseUrl + "/api/apps/primus/Vaults/{id}";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ = <RequestInit>{
            body: content_,
            method: "PUT",
            headers: {
                "Content-Type": "application/json",
                "Accept": "text/plain"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.transformResult(url_, _response, (_response: Response) => this.processVaultsPUT(_response));
        });
    }

    protected processVaultsPUT(response: Response): Promise<VaultApiModel> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = VaultApiModel.fromJS(resultData200);
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<VaultApiModel>(<any>null);
    }

    /**
     * @return Success
     */
    vaultsDELETE(id: number): Promise<VaultApiModel> {
        let url_ = this.baseUrl + "/api/apps/primus/Vaults/{id}";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        let options_ = <RequestInit>{
            method: "DELETE",
            headers: {
                "Accept": "text/plain"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.transformResult(url_, _response, (_response: Response) => this.processVaultsDELETE(_response));
        });
    }

    protected processVaultsDELETE(response: Response): Promise<VaultApiModel> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = VaultApiModel.fromJS(resultData200);
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<VaultApiModel>(<any>null);
    }

    /**
     * @return Success
     */
    archive(id: number): Promise<VaultApiModel> {
        let url_ = this.baseUrl + "/api/apps/primus/Vaults/archive/{id}";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        let options_ = <RequestInit>{
            method: "DELETE",
            headers: {
                "Accept": "text/plain"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.transformResult(url_, _response, (_response: Response) => this.processArchive(_response));
        });
    }

    protected processArchive(response: Response): Promise<VaultApiModel> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = VaultApiModel.fromJS(resultData200);
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<VaultApiModel>(<any>null);
    }
}

export class VaultApiModel implements IVaultApiModel {
    id?: number;
    legacyKnowledgebaseId?: string | undefined;
    title?: string | undefined;
    description?: string | undefined;
    playlistCount?: number;
    sectionCount?: number;
    deckCount?: number;
    feedCount?: number;
    projectCount?: number;
    boardCount?: number;
    initiativeCount?: number;

    constructor(data?: IVaultApiModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.legacyKnowledgebaseId = _data["legacyKnowledgebaseId"];
            this.title = _data["title"];
            this.description = _data["description"];
            this.playlistCount = _data["playlistCount"];
            this.sectionCount = _data["sectionCount"];
            this.deckCount = _data["deckCount"];
            this.feedCount = _data["feedCount"];
            this.projectCount = _data["projectCount"];
            this.boardCount = _data["boardCount"];
            this.initiativeCount = _data["initiativeCount"];
        }
    }

    static fromJS(data: any): VaultApiModel {
        data = typeof data === 'object' ? data : {};
        let result = new VaultApiModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["legacyKnowledgebaseId"] = this.legacyKnowledgebaseId;
        data["title"] = this.title;
        data["description"] = this.description;
        data["playlistCount"] = this.playlistCount;
        data["sectionCount"] = this.sectionCount;
        data["deckCount"] = this.deckCount;
        data["feedCount"] = this.feedCount;
        data["projectCount"] = this.projectCount;
        data["boardCount"] = this.boardCount;
        data["initiativeCount"] = this.initiativeCount;
        return data; 
    }
}

export interface IVaultApiModel {
    id?: number;
    legacyKnowledgebaseId?: string | undefined;
    title?: string | undefined;
    description?: string | undefined;
    playlistCount?: number;
    sectionCount?: number;
    deckCount?: number;
    feedCount?: number;
    projectCount?: number;
    boardCount?: number;
    initiativeCount?: number;
}

export class VaultCreationRequest implements IVaultCreationRequest {
    vaultName!: string;
    description!: string;
    username?: string | undefined;
    legacyKnowledgebaseId?: string | undefined;

    constructor(data?: IVaultCreationRequest) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.vaultName = _data["vaultName"];
            this.description = _data["description"];
            this.username = _data["username"];
            this.legacyKnowledgebaseId = _data["legacyKnowledgebaseId"];
        }
    }

    static fromJS(data: any): VaultCreationRequest {
        data = typeof data === 'object' ? data : {};
        let result = new VaultCreationRequest();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["vaultName"] = this.vaultName;
        data["description"] = this.description;
        data["username"] = this.username;
        data["legacyKnowledgebaseId"] = this.legacyKnowledgebaseId;
        return data; 
    }
}

export interface IVaultCreationRequest {
    vaultName: string;
    description: string;
    username?: string | undefined;
    legacyKnowledgebaseId?: string | undefined;
}

export class VaultUpdateRequest implements IVaultUpdateRequest {
    vaultName?: string | undefined;
    description?: string | undefined;
    legacyKnowledgebaseId?: string | undefined;

    constructor(data?: IVaultUpdateRequest) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.vaultName = _data["vaultName"];
            this.description = _data["description"];
            this.legacyKnowledgebaseId = _data["legacyKnowledgebaseId"];
        }
    }

    static fromJS(data: any): VaultUpdateRequest {
        data = typeof data === 'object' ? data : {};
        let result = new VaultUpdateRequest();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["vaultName"] = this.vaultName;
        data["description"] = this.description;
        data["legacyKnowledgebaseId"] = this.legacyKnowledgebaseId;
        return data; 
    }
}

export interface IVaultUpdateRequest {
    vaultName?: string | undefined;
    description?: string | undefined;
    legacyKnowledgebaseId?: string | undefined;
}

export class ApiException extends Error {
    message: string;
    status: number;
    response: string;
    headers: { [key: string]: any; };
    result: any;

    constructor(message: string, status: number, response: string, headers: { [key: string]: any; }, result: any) {
        super();

        this.message = message;
        this.status = status;
        this.response = response;
        this.headers = headers;
        this.result = result;
    }

    protected isApiException = true;

    static isApiException(obj: any): obj is ApiException {
        return obj.isApiException === true;
    }
}

function throwException(message: string, status: number, response: string, headers: { [key: string]: any; }, result?: any): any {
    throw new ApiException(message, status, response, headers, result);
}